import {
  blue,
  teal,
  amber,
  purple,
  deepOrange,
  green,
  indigo,
  cyan,
  lightBlue,
  brown,
} from "@mui/material/colors";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import AssignmentIndRoundedIcon from "@mui/icons-material/AssignmentIndRounded";
import PersonAddAltRoundedIcon from "@mui/icons-material/PersonAddAltRounded";
import CategoryRoundedIcon from "@mui/icons-material/CategoryRounded";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import Inventory2RoundedIcon from "@mui/icons-material/Inventory2Rounded";
import AddShoppingCartRoundedIcon from "@mui/icons-material/AddShoppingCartRounded";
import LocalShippingRoundedIcon from "@mui/icons-material/LocalShippingRounded";
import WarehouseRoundedIcon from "@mui/icons-material/WarehouseRounded";
import PinDropRoundedIcon from "@mui/icons-material/PinDropRounded";
import AccountBalanceRoundedIcon from "@mui/icons-material/AccountBalanceRounded";
import * as DefaultRoutes from "@Routes/DefaultRoutes";
import GenericHomePage from "../../GenericHomePage/GenericHomePage";
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import StorefrontIcon from "@mui/icons-material/Storefront";
const AdminHome = () => {
  const navigate = useNavigate();

  const theme = useTheme();
  let sectionsBox = [
    {
      textBeside: "Users", // Label displayed next to the icon
      icon: PersonAddAltRoundedIcon, // MUI Icon component
      iconColor: blue[800], // Icon color
      iconFontSize: theme.spacing(10), // Icon size
      boxbackgroundColor: blue[50], // Box background color
      onClick: () => navigate(DefaultRoutes.users), // Action on click
    },
    {
      textBeside: "Categories",
      icon: CategoryRoundedIcon,
      iconColor: amber[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: amber[50],
      onClick: () => navigate(DefaultRoutes.categories),
    },
    {
      textBeside: "Suppliers",
      icon: Inventory2RoundedIcon,
      iconColor: deepOrange[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: deepOrange[50],
      onClick: () => navigate(DefaultRoutes.suppliers),
    },
    {
      textBeside: "Materials",
      icon: AddShoppingCartRoundedIcon,
      iconColor: purple[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: purple[50],
      onClick: () => navigate(DefaultRoutes.materials),
    },
    {
      textBeside: "Warehouses",
      icon: WarehouseRoundedIcon,
      iconColor: brown[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: brown[50],
      onClick: () => navigate(DefaultRoutes.warehouses),
    },
    {
      textBeside: "Banks",
      icon: AccountBalanceRoundedIcon,
      iconColor: green[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: green[50],
      onClick: () => navigate(DefaultRoutes.banks),
    },
    {
      textBeside: "Planners",
      icon: AssignmentIndIcon,
      iconColor: indigo[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: indigo[50],
      onClick: () => navigate(DefaultRoutes.planners),
    },
    {
      textBeside: "Storage Locations",
      icon: PinDropRoundedIcon,
      iconColor: lightBlue[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: lightBlue[50],
      onClick: () => navigate(DefaultRoutes.storageLocations),
    },
    {
      textBeside: "Clearance Agents",
      icon: AssignmentIndRoundedIcon,
      iconColor: teal[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: teal[50],
      onClick: () => navigate(DefaultRoutes.clearanceAgents),
    },
    {
      textBeside: "Vendors",
      icon: StorefrontIcon,
      iconColor: teal[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: teal[50],
      onClick: () => navigate(DefaultRoutes.vendors),
    },
    {
      textBeside: "Shipping Lines",
      icon: LocalShippingRoundedIcon,
      iconColor: cyan[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: cyan[50],
      onClick: () => navigate(DefaultRoutes.shippingLines),
    },
    {
      textBeside: "Bulk Insert",
      icon: LibraryAddIcon,
      iconColor: cyan[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: cyan[50],
      onClick: () => navigate(DefaultRoutes.bulkInsert),
    },
  ];

  return <GenericHomePage sectionsBox={sectionsBox} />;
};

export default AdminHome;
